import Plugins from "./Plugins";

export default Plugins;
